import React, { useState } from 'react';
import './App.css';
import Icon from './icons';
import { ThemeToggle } from './theme';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

function ResellerLogin({ onLoginSuccess }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const res = await fetch(`${API_URL}/reseller/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            });

            const data = await res.json();

            if (!res.ok || data.error) {
                setError(data.error || 'Login failed');
            } else {
                // Store token and reseller info
                localStorage.setItem('resellerToken', data.token);
                localStorage.setItem('resellerInfo', JSON.stringify(data.reseller));
                onLoginSuccess(data.reseller, data.token);
            }
        } catch (err) {
            setError('Failed to connect to server: ' + err.message);
        }
        setLoading(false);
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-theme-toggle">
                    <ThemeToggle compact />
                </div>
                <div className="login-header">
                    <div className="login-icon"><Icon name="lock" size={40} /></div>
                    <h1>Reseller Portal</h1>
                    <p>Sign in to manage your licenses</p>
                </div>

                {error && (
                    <div className="login-error">
                        <span><Icon name="alert" size={16} /></span>
                        <span>{error}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">Username</label>
                        <input
                            type="text"
                            className="form-input"
                            placeholder="Enter your username"
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            required
                            autoFocus
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label">Password</label>
                        <input
                            type="password"
                            className="form-input"
                            placeholder="Enter your password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="btn btn-primary login-btn"
                    >
                        {loading ? 'Signing in…' : 'Sign in'}
                    </button>
                </form>

                <div className="login-footer">
                    <p>Need an account? Contact your administrator.</p>
                </div>
            </div>
        </div>
    );
}

export default ResellerLogin;
